module.exports = __webpack_public_path__ + "static/security4@3x-0d24542acab12bd7b3b3240356c2c901.png";